var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ complete: _vm.goal.complete },attrs:{"id":"list-item"},on:{"click":_vm.onClick}},[_c('split-text',{attrs:{"type":'words',"classname":'question-copy'}},[_vm._v("\n    "+_vm._s(_vm.getCopy)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }